export default "__VITE_ASSET__BrubVEdR__"